import { __assign, __read, __rest } from "tslib";
import React, { useEffect, useState } from 'react';
import { Dropdown } from '@mercell/dropdown-react';
import { useFetchNuts } from './useFetchNuts';
import { nutsByCountryCode } from './convertIsoToNuts';
var baseURI = 'https://api.beta.mercell.com/nuts';
export var NutsSelector = function (_a) {
    var onChangeCallback = _a.onChangeCallback, priorityCountryAbbr = _a.priorityCountryAbbr, _b = _a.disableTopLevelNuts, disableTopLevelNuts = _b === void 0 ? false : _b, _c = _a.disableAllButNUTS3, disableAllButNUTS3 = _c === void 0 ? false : _c, _d = _a.selfDisableComponentIfNoValues, selfDisableComponentIfNoValues = _d === void 0 ? false : _d, _e = _a.nutsFetchCallback, nutsFetchCallback = _e === void 0 ? function () { return null; } : _e, restProps = __rest(_a, ["onChangeCallback", "priorityCountryAbbr", "disableTopLevelNuts", "disableAllButNUTS3", "selfDisableComponentIfNoValues", "nutsFetchCallback"]);
    var _f = __read(useState(''), 2), searchValue = _f[0], setSearchValue = _f[1];
    var finalUrl = baseURI;
    if (priorityCountryAbbr) {
        var upperCasePriorityCountryAbbr = priorityCountryAbbr.toUpperCase();
        finalUrl = "".concat(finalUrl, "/").concat(nutsByCountryCode(upperCasePriorityCountryAbbr) ||
            upperCasePriorityCountryAbbr);
    }
    if (searchValue) {
        finalUrl = "".concat(finalUrl, "?any=").concat(searchValue);
    }
    var _g = useFetchNuts(finalUrl, disableTopLevelNuts, disableAllButNUTS3), nutsCodes = _g.nutsCodes, isLoadingNuts = _g.isLoadingNuts, isErrorFetchingNuts = _g.isErrorFetchingNuts;
    var onChange = function (selectedCodes) {
        if (restProps.isMulti) {
            if (selectedCodes && selectedCodes.length) {
                onChangeCallback(selectedCodes.map(function (code) { return code.value; }));
            }
            else {
                onChangeCallback([]);
            }
        }
        else if (selectedCodes) {
            onChangeCallback(selectedCodes.value);
        }
        else {
            onChangeCallback('');
        }
    };
    var dropdownValue = nutsCodes === null || nutsCodes === void 0 ? void 0 : nutsCodes.filter(function (option) {
        var isMulti = restProps.isMulti, value = restProps.value;
        if (isMulti) {
            return value instanceof Array
                ? value.includes(option.value)
                : false;
        }
        return option.value === value;
    });
    var isDisabled = restProps.isDisabled ||
        (selfDisableComponentIfNoValues &&
            !isLoadingNuts &&
            nutsCodes &&
            nutsCodes.length === 0);
    useEffect(function () {
        if (!isLoadingNuts && !isErrorFetchingNuts) {
            nutsFetchCallback(nutsCodes);
        }
    }, [nutsCodes, nutsFetchCallback, isErrorFetchingNuts, isLoadingNuts]);
    return (React.createElement(Dropdown, __assign({}, restProps, { styles: {
            option: function (provided, state) { return (__assign(__assign({}, provided), { paddingLeft: state.data.paddingLeft })); },
        }, isDisabled: isDisabled, isLoading: isLoadingNuts, inputValue: searchValue, options: nutsCodes, onInputChange: setSearchValue, onChange: onChange, filterOption: null, value: dropdownValue })));
};
